import React from "react";
import styled from "@emotion/styled";
import { useTheme } from "@emotion/react";
import Image from "@components/item/Image";
import { motion, AnimatePresence } from "framer-motion";

const ChecktBoxInput = styled.button(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "1.6rem",
  fontSize: "1.6rem",
  lineHeight: "1.6rem",
  border: `1px solid ${theme.color.black}`,
}));

const Left = styled.div(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "1rem",
}));

type Props = {
  isShow: boolean;
};

const SearchDropdownInput = ({ isShow }: Props) => {
  const theme = useTheme();

  return (
    <AnimatePresence>
      {isShow && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.2 }}>
          <ChecktBoxInput>
            <Left>
              <Image src={theme.image.search_icon.default} size="1.8rem" />
              <span>브랜드 검색하여 선택</span>
            </Left>
            <Image src={theme.image.arrow_right.default} size="2rem" />
          </ChecktBoxInput>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default SearchDropdownInput;
